<a [routerLink]="['/product', id]">{{name}}</a>
